import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_btn = _resolveComponent("menu-btn")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_left_menu = _resolveComponent("left-menu")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_tab_menu = _resolveComponent("tab-menu")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { style: {"height":"100%","width":"100%"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, _mergeProps({
        style: _ctx.hideMenu ? { width: '40px' } : { overflow: 'auto' },
        id: "frame-body-left"
      }, _ctx.menuProps, { class: "dnymenu" }), {
        default: _withCtx(() => [
          _createVNode(_component_a_layout, { style: {"height":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_header, { style: {"height":"30px","padding":"0px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_menu_btn, {
                    showMode: _ctx.showMode,
                    onMenuBtnClick: _ctx.handleChangeMenu
                  }, null, 8, ["showMode", "onMenuBtnClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_layout_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_left_menu, {
                    style: _normalizeStyle(_ctx.hideMenu ? { width: '40px' } : ''),
                    onShowMenu: _ctx.handleShowMenu,
                    onMenuitemClick: _ctx.handleMenuClick,
                    onMenuSearch: _ctx.handleSearch,
                    "menu-tree": _ctx.showModules,
                    showMode: _ctx.showMode,
                    theme: _ctx.theme,
                    showQueryMenu: _ctx.showQueryMenu,
                    collapsed: _ctx.hideMenu
                  }, null, 8, ["style", "onShowMenu", "onMenuitemClick", "onMenuSearch", "menu-tree", "showMode", "theme", "showQueryMenu", "collapsed"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["style"]),
      _createVNode(_component_a_col, _mergeProps(_ctx.mainProps, {
        style: _ctx.hideMenu ? { width: _ctx.collapseWidth } : {}
      }), {
        default: _withCtx(() => [
          _createVNode(_component_tab_menu, {
            ref: "reftabMenu",
            ifShowTab: _ctx.ifShowTab,
            selectKey: _ctx.selectKey,
            "menu-tree": _ctx.showModules
          }, null, 8, ["ifShowTab", "selectKey", "menu-tree"])
        ]),
        _: 1
      }, 16, ["style"])
    ]),
    _: 1
  }))
}